import { useContext } from 'react';

import { ExamEventScoreReportContext } from './exam-event-score-report-provider';

export function useExamEventScoreReport() {
  const context = useContext(ExamEventScoreReportContext);

  if (!context) {
    throw new Error('useExamEventScoreReport must be used within an ExamEventScoreReportProvider');
  }

  return context;
}
